import { render, staticRenderFns } from "./VehicleGroupTypesSection.vue?vue&type=template&id=da3b4de4&"
import script from "./VehicleGroupTypesSection.vue?vue&type=script&lang=js&"
export * from "./VehicleGroupTypesSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QTable,QTr,QTh,QTd,QBtn,QTooltip,QCardSection,QInnerLoading,QSpinnerGears} from 'quasar'
component.options.components = Object.assign({QTable,QTr,QTh,QTd,QBtn,QTooltip,QCardSection,QInnerLoading,QSpinnerGears}, component.options.components || {})
